import { render, staticRenderFns } from "./SongSearch.vue?vue&type=template&id=0df4e9ef"
import script from "./SongSearch.vue?vue&type=script&lang=js"
export * from "./SongSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports